import { render, staticRenderFns } from "./viewChangeLogModal.vue?vue&type=template&id=c8e06f6a&scoped=true"
import script from "./viewChangeLogModal.vue?vue&type=script&lang=js"
export * from "./viewChangeLogModal.vue?vue&type=script&lang=js"
import style0 from "./viewChangeLogModal.vue?vue&type=style&index=0&id=c8e06f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e06f6a",
  null
  
)

export default component.exports